import { Grid, Divider, Box } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ControlledTextInput, WsSelect, WsButton } from 'wisestep-base';

import { ActionComponent, RuleComponent } from '../IfandThenCards';

const JobEntityOptions = [
  { label: 'Job', value: 'JOB' },
  { label: 'Candidate', value: 'CANDIDATE' },
  { label: 'Submission', value: 'SUBMISSION' },
];

const SelectTrigger = [
  { label: 'Job Created', value: 'CREATED' },
  { label: 'Job Updated', value: 'UPDATED' },
  { label: 'Job Closed', value: 'CLOSED' },
  { label: 'Job Opened', value: 'OPEN' },
];

interface AddAutomationContentProps {
  isEditMode?: boolean;
  onSubmit?: (data: any) => void;
  onCancel?: () => void;
  isLoading?: boolean;
  submitButtonText?: string;
  showActions?: boolean;
}

export const AddAutomationContent: React.FC<AddAutomationContentProps> = ({
  isEditMode = false,
  onSubmit,
  onCancel,
  isLoading = false,
  submitButtonText,
  showActions = true,
}) => {
  const { setValue, watch, handleSubmit } = useFormContext();

  const handleFormSubmit = (data: any) => {
    if (onSubmit) {
      onSubmit(data);
    }
  };

  const handleCancelClick = () => {
    onCancel?.();
  };

  const getSubmitButtonText = () => {
    if (submitButtonText) return submitButtonText;
    if (isLoading) return isEditMode ? 'Updating...' : 'Creating...';
    return isEditMode ? 'Update' : 'Save';
  };

  return (
    <>
      <Grid container spacing={2} flexDirection="column" rowGap={1.5} mt={3}>
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <ControlledTextInput
              name="automationName"
              labelText="Automation Name *"
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={5}>
            <WsSelect
              name="entityType"
              label="Select Entity *"
              selectArray={JobEntityOptions}
              onChangeValue={(val) => setValue('entityType', val)}
              defaultValue={watch('entityType') || ''}
            />
          </Grid>
          <Grid item xs={5}>
            <WsSelect
              name="selectTrigger"
              label="Select trigger *"
              selectArray={SelectTrigger}
              onChangeValue={(val) => setValue('selectTrigger', val)}
              defaultValue={watch('selectTrigger') || ''}
            />
          </Grid>
        </Grid>

        <Divider />

        <RuleComponent />

        <Divider />

        <ActionComponent />
      </Grid>

      {showActions && (
        <Box mt={4} display="flex" gap={2} justifyContent="flex-start">
          <WsButton
            variant="contained"
            onClick={handleSubmit(handleFormSubmit)}
            disabled={isLoading}
          >
            {getSubmitButtonText()}
          </WsButton>

          {(isEditMode || onCancel) && (
            <WsButton variant="outlined" onClick={handleCancelClick} disabled={isLoading}>
              Cancel
            </WsButton>
          )}
        </Box>
      )}
    </>
  );
};
